import React, { useMemo } from 'react';
import Badge from '../../components/ui/Badge';
import { ReferenceDataGeneralList, type ReferenceInboxColumn } from '../parameters/ReferenceDataGeneralList';
import { moduleConfig } from './config';
import { useSuppliers, type Supplier } from './useData';

const List: React.FC = () => {
  const formatDate = moduleConfig.utils.formatDate;
  const columns = useMemo<ReferenceInboxColumn<Supplier>[]>(
    () => [
      {
        key: 'name',
        header: 'Name',
        render: (row) => <span className="font-medium">{row.name}</span>,
      },
      {
        key: 'code',
        header: 'Code',
        render: (row) => row.code || '',
      },
      {
        key: 'email',
        header: 'Email',
        render: (row) => row.email || '',
      },
      {
        key: 'phone',
        header: 'Phone',
        render: (row) => row.phone || '',
      },
      {
        key: 'isActive',
        header: 'Active',
        render: (row) => (
          <Badge variant={row.isActive ? 'success' : 'danger'}>{row.isActive ? 'Yes' : 'No'}</Badge>
        ),
      },
      {
        key: 'createdAt',
        header: 'Created',
        render: (row) => formatDate(row.createdAt),
      },
    ],
    [formatDate],
  );

  return (
    <ReferenceDataGeneralList
      moduleConfig={moduleConfig}
      useData={useSuppliers}
      columns={columns}
      defaultSort={{ key: 'name', direction: 'asc' }}
      newLabel="New entity"
      getRowLabel={(row) => row.name}
    />
  );
};

export default List;
